import React from 'react';
import PropTypes from 'prop-types';
import {
    Row,
    Col,
    Divider,
    Button,
} from 'antd';
import BookingTableRowItemValue from './BookingTableRowItemValue';
import { createDashboardRowData } from '../../utils';


const propTypes = {
    record: PropTypes.object.isRequired,
};

const BookingTableRowCustomer = ({ record, handleCancelClick }) => {
    if (!record) return null;

    const values = createDashboardRowData(record);

    return (
        <Row>
            <Row gutter={40}>
                <Col span={8}>
                    <BookingTableRowItemValue label="End Time" value={values.end_time} />
                    <BookingTableRowItemValue label="Contact Number" value={values.contact_number} />
                </Col>
                <Col span={8}>
                    {
                        record.booking_cancelled &&
                        <>
                            <BookingTableRowItemValue label="Cancelled On" value={values.cancelled_at} />
                        </>
                    }
                </Col>
            </Row>
            <Divider />
            {
                !record.booking_cancelled &&
                <Row gutter={40}>
                    <Col span={24}>
                        <Button onClick={handleCancelClick(record)}>
                            Cancel booking
                        </Button>
                    </Col>
                </Row>
            }
        </Row>
    );
};

BookingTableRowCustomer.propTypes = propTypes;

export default BookingTableRowCustomer;
